import { Quote } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { UserBadge } from "@/components/UserBadge";
import { pillarLabel } from "@/lib/pillars";
import type { StoryPublic } from "@/lib/coachesQueries";

export function StoryCard({ story }: { story: StoryPublic }) {
  const initials = (story.display_name ?? "A").slice(0, 2).toUpperCase();
  return (
    <Card className="flex flex-col gap-3 border-border/50 bg-card/80 p-6 backdrop-blur">
      <div className="flex items-center gap-3">
        <Avatar className="h-10 w-10">
          {story.avatar_url && <AvatarImage src={story.avatar_url} alt={`Profile photo of ${story.display_name ?? "AGES member"}`} />}
          <AvatarFallback>{initials}</AvatarFallback>
        </Avatar>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <p className="truncate text-sm font-semibold">{story.display_name ?? "Anonymous"}</p>
            {story.current_badge_tier && (
              <UserBadge tier={story.current_badge_tier as any} size="sm" />
            )}
          </div>
          <p className="text-xs text-muted-foreground">{pillarLabel(story.selected_pillar)}</p>
        </div>
      </div>

      {story.quote && (
        <div className="flex gap-2 text-sm italic text-foreground/90">
          <Quote className="h-4 w-4 shrink-0 text-gold" />
          <p>{story.quote}</p>
        </div>
      )}

      <div className="mt-auto border-t border-border/30 pt-3">
        <p className="text-xs text-muted-foreground">Total impact</p>
        <p className="text-lg font-bold text-gradient-charity">
          ${(story.total_impact_cents / 100).toFixed(2)}
        </p>
      </div>
    </Card>
  );
}
